import Toast, { POSITION } from "vue-toastification";
import type { PluginOptions } from "vue-toastification";

const options: PluginOptions = {
  position: POSITION.BOTTOM_RIGHT,
  toastClassName: "toast-container",
  icon: false,
  closeButton: false,
  transition: "Vue-Toastification__fade",
  timeout: 5000,
};

export default defineNuxtPlugin({
  name: "toastificationPlugin",
  parallel: true,
  async setup(nuxtApp) {
    nuxtApp.vueApp.use(Toast, options);
  },
});
